import React from "react";
import { Form, DatePicker } from "antd";

export function InputDate(props) {
  const [form] = Form.useForm();

  return (
    <Form.Item
      name={props.name}
      label={props.label}
      initialValue={props.initialValue}
      rules={[
        {
          required: props.required,
          message: props.errorMessage,
        },
      ]}
    >
      <DatePicker
        format={props.format}
        style={props.style}
        form={form}
        defaultValue={props.defaultValue}
        onChange={props.onChange}
        allowClear={props.allowClear}
        placeholder={props.placeholder}
        dateRender={props.dateRender}
        nextIcon={props.nextIcon}
        prevIcon={props.prevIcon}
        size={props.size}
        disabled={props.disabled}
        disabledDate={props.disabledDate}
        showTime={props.showTime}
        picker={props.picker}
      />
    </Form.Item>
  );
}

InputDate.defaultProps = {
  allowClear: true
};
